import { render } from "./RecuperarCuenta.vue?vue&type=template&id=9e766e48&scoped=true"
import script from "./RecuperarCuenta.vue?vue&type=script&lang=js"
export * from "./RecuperarCuenta.vue?vue&type=script&lang=js"

import "./RecuperarCuenta.vue?vue&type=style&index=0&id=9e766e48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e766e48"]])

export default __exports__